<div
  class="info-table-item"
  [ngStyle]="{
    background:
      status === 'ACTIVE' &&
      data?.site?.siteVisitRequired &&
      !data?.proposal?.selectedSiteVisit &&
      !(
        data?.proposal?.siteVisit1 ||
        data?.proposal?.siteVisit2 ||
        data?.proposal?.siteVisit3
      )
        ? 'var(--background-5)'
        : 'transparent'
  }"
>
  <ng-container *ngIf="showStatus">
    <ng-container *ngIf="type === 'proposals'">
      <p
        class="status --proposal"
        *ngIf="status === 'SUBMITTED' || status === 'PROPOSAL'"
      >
        Submitted
      </p>
      <p class="status --bid-won" *ngIf="status === 'BID_WON'">Awarded</p>
      <p
        class="status --bid-lost"
        *ngIf="status === 'BID_LOST' || status === 'NO_RESPONSE'"
      >
        Not Awarded
      </p>
    </ng-container>
    <ng-container *ngIf="type === 'active'">
      <p class="status --active">Active</p>
    </ng-container>
    <ng-container *ngIf="type === 'invitations'">
      <p class="status --invitation" *ngIf="status === 'INVITATION'">
        Invitation
      </p>
      <p class="status --offered" *ngIf="status === 'OFFERED'">Offered</p>
    </ng-container>
  </ng-container>
  <div class="address" *ngIf="showSite">
    <p class="address__site">#{{ site }}</p>
    <div class="address__address">
      <span
        class="material-icons address-pointer"
        [ngStyle]="
          data?.site?.specialSiteCondition
            ? { color: 'var(--error)', fontWeight: 'bold' }
            : { color: 'var(--text)' }
        "
        matTooltip="Click here for more info on Site Requirements."
        matTooltipPosition="above"
    matTooltipClass="site-req-tooltip"
        [matTooltipDisabled]="!data?.site?.specialSiteCondition"
        (click)="toggleMapModal(type, id)"
        >info_outline</span
      >
      <div class="address-pointer" [routerLink]="['/', type, id]">
        <p>
          <span *ngIf="address.streetAddress"
            >{{ address.streetAddress }}<br /></span
          >{{ address.cityStateZip }}
        </p>
      </div>
    </div>
  </div>
  <p *ngIf="showAcreage" class="table-row-font">{{ acreage }}</p>
  <div
    *ngIf="showSiteType"
    class="address-pointer"
    [routerLink]="['/', type, id]"
  >
    <div class="service-type">
      <p>{{ siteSubType ? siteType + " - " + siteSubType : siteType }}</p>
    </div>
  </div>
  <p *ngIf="showLandUse" class="table-row-font">
    {{ landUse || "Not Provided" }}
  </p>

  <div
    *ngIf="showSiteRequirements"
    class="site-req"
    [ngClass]="{ 'site-req--active': data?.site?.specialSiteCondition || (data?.site?.tableAChanges && (data?.site?.tableAChanges?.itemsAdded || data?.site?.tableAChanges?.itemsRemoved)) }"
    [matTooltip]="getFullSiteReqTooltip()"
    [matTooltipDisabled]="!data?.site?.specialSiteCondition && !(data?.site?.tableAChanges?.itemsAdded || data?.site?.tableAChanges?.itemsRemoved)"
    matTooltipPosition="above"
    matTooltipClass="site-req-tooltip"
  >
    <ng-container *ngIf="data?.site?.tableAChanges && (data?.site?.tableAChanges?.itemsAdded || data?.site?.tableAChanges?.itemsRemoved)">
      <div class="site-req__table-a">
        <p class="table-row-font"><strong>Table A:</strong></p>
        <p *ngIf="data?.site?.tableAChanges?.itemsAdded" class="table-row-font site-req__added">+ {{ data.site.tableAChanges.itemsAdded }}</p>
        <p *ngIf="data?.site?.tableAChanges?.itemsRemoved" class="table-row-font site-req__removed">− {{ data.site.tableAChanges.itemsRemoved }}</p>
      </div>
      <hr *ngIf="data?.site?.specialSiteCondition" class="site-req__divider" />
    </ng-container>
    <p *ngIf="data?.site?.specialSiteCondition" class="table-row-font">{{
      data?.site?.specialSiteCondition?.length > 100
        ? (data?.site?.specialSiteCondition | slice:0:100) + '...'
        : data?.site?.specialSiteCondition
    }}</p>
  </div>

  <div
    *ngIf="
      data.proposal.status === 'BID_LOST' ||
        data.proposal.status === 'NO_RESPONSE';
      else notBidLost
    "
  >
    <div class="info-table-item__docs-info">
      <span class="info-table-item__icon-text">
        <div class="documents-disabled">
          <span class="material-icons">upload</span>
          <div *ngIf="documents?.length > 0" class="documents__number">
            {{ documents?.length }}
          </div>
        </div>
        <span class="documents-label-disabled">Documents</span>
      </span>
      <span class="info-table-item__icon-text">
        <div class="documents-disabled">
          <span class="material-icons">notes</span>
        </div>
        <span class="documents-label-disabled">Notes</span>
      </span>
    </div>
  </div>
  <ng-template #notBidLost>
    <div class="info-table-item__docs-info">
      <span class="info-table-item__icon-text" *ngIf="!isAlta">
        <div class="documents" (click)="toggleExpensesModal()">
          <span class="material-icons">wallet</span>
        </div>
        <span class="documents-label">Expenses</span>
      </span>
      <span class="info-table-item__icon-text">
        <div class="documents" (click)="toggleOpenDocumentsModal()">
          <span class="material-icons">upload</span>
          <div *ngIf="documents?.length > 0" class="documents__number">
            {{ documents?.length }}
          </div>
        </div>
        <span class="documents-label">Documents</span>
      </span>
      <span class="info-table-item__icon-text">
        <div class="documents" (click)="toggleNotesModal()">
          <span class="material-icons">notes</span>
        </div>
        <span class="documents-label">Notes</span>
      </span>
    </div>
  </ng-template>

  <ng-container *ngIf="showActions">
    <div
      *ngIf="
        (type === 'invitations' && status === 'OFFERED') ||
        type === 'proposals'
      "
      class="proposals-actions"
    >
      <div class="turn-time" *ngIf="!isDesiredByDate">
        <p>
          <span *ngIf="isFixedPriced; else tat">Due Date</span>
          <ng-template #tat>Turn Time</ng-template>
        </p>
        <span *ngIf="isFixedPriced; else tt"
          ><p>
            {{
              data.proposal.proposedDeliverDate | date : "MM/dd/yyyy" : locale
            }}
          </p></span
        >
        <ng-template #tt>
          <p>{{ turnTime }} Days</p>
        </ng-template>
      </div>
      <div *ngIf="isDesiredByDate" class="table-row-font">
        <p class="info-table-actions-edit__item__label">Due Date</p>
        <p>
          {{ desiredByDate | date : "MM/dd/yyyy" : locale }}
        </p>
      </div>
      <div class="bid-amount">
        <p *ngIf="!isFixedPriced; else offer">Bid Amount</p>
        <ng-template #offer>
          <p>Offer Amount</p>
        </ng-template>
        <p>{{ bidAmount | currency : "USD" : "symbol" : "1.0-0" }}</p>
      </div>
    </div>
    <div
      *ngIf="type === 'invitations' && status !== 'OFFERED'"
      class="info-table-actions-edit"
    >
      <div *ngIf="isDesiredByDate" class="table-row-font">
        <p class="info-table-actions-edit__item__label">Due Date</p>
        <p>
          {{ desiredByDate | date : "MM/dd/yyyy" : locale }}
        </p>
      </div>
      <div *ngIf="!isDesiredByDate">
        <div class="info-table-actions-edit__item">
          <p class="info-table-actions-edit__item__label">Turn Time</p>
          <div class="info-table-actions-edit__item__input">
            <div class="input-container">
              <input
                id="invitationTurnTime{{ rowIndex }}"
                type="number"
                placeholder="Business Days"
                [(ngModel)]="turnTime"
                (blur)="saveTurnTime()"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="info-table-actions-edit__item">
        <p
          class="info-table-actions-edit__item__label"
          *ngIf="!isFixedPriced; else offer"
        >
          Bid Amount
        </p>
        <ng-template #offer>
          <p class="info-table-actions-edit__item__label">Offer Amount</p>
        </ng-template>
        <div class="info-table-actions-edit__item__input">
          <input
            id="invitationBidAmount{{ rowIndex }}"
            type="number"
            placeholder="$"
            value=""
            [(ngModel)]="bidAmount"
            (blur)="saveBidAmount()"
          />
        </div>
      </div>
    </div>
    <div
      *ngIf="type === 'active'"
      class="info-table-review submit-review-align"
    >
      <button
        class="site-visit-button"
        [ngStyle]="{ background: 'var(--error)', color: 'white' }"
        *ngIf="
          status === 'ACTIVE' &&
          data?.site?.siteVisitRequired &&
          !data?.proposal?.selectedSiteVisit &&
          !(
            data?.proposal?.siteVisit1 ||
            data?.proposal?.siteVisit2 ||
            data?.proposal?.siteVisit3
          )
        "
        (click)="toggleSiteVistModal()"
      >
        Schedule Site Visit
      </button>
      <button
        class="submit-review-revision-button"
        [disabled]="!showReviewSubmission"
        *ngIf="
          status === 'ACTIVE' &&
          (!data?.site?.siteVisitRequired ||
            (data?.site?.siteVisitRequired &&
              (data?.proposal?.selectedSiteVisit ||
                data?.proposal?.siteVisit1 ||
                data?.proposal?.siteVisit2 ||
                data?.proposal?.siteVisit3)))
        "
        [ngStyle]="{
          background: showReviewSubmission ? 'var(--text)' : '#cfcfcf',
          color: showReviewSubmission ? '#ffffff' : 'var(--text)'
        }"
        (click)="submitProposal()"
      >
        {{
          !showReviewSubmission
            ? "Deliverable Document Required"
            : "Submit Review"
        }}
      </button>
      <button
        class="submit-review-revision-button"
        *ngIf="status === 'REVISION_REQUESTED'"
        [disabled]="!showRevisionSubmission"
        [ngStyle]="{
          background: showRevisionSubmission ? 'var(--text)' : '#cfcfcf',
          color: showRevisionSubmission ? '#ffffff' : 'var(--text)'
        }"
        (click)="submitProposal()"
      >
        {{
          !showRevisionSubmission
            ? "Revision Document Required"
            : "Submit Revision"
        }}
      </button>
      <p
        class="pending-review-label"
        *ngIf="data.proposal.status === 'REVIEW_PENDING'"
      >
        Review Pending
      </p>
      <p
        class="pending-review-label"
        *ngIf="data.proposal.status === 'REVISION_PENDING'"
      >
        Revision Pending
      </p>
      <div class="proposals-actions">
        <span class="price">
          Fee: {{ bidAmount | currency : "USD" : "symbol" : "1.0-0" }}
        </span>
      </div>
      <div class="proposals-actions">
        <span class="active-delivery-date">
          Due Date:
          {{
            (isDesiredByDate
              ? desiredByDate
              : data.proposal.proposedDeliverDate
            ) | date : "MM/dd/yyyy" : locale
          }}
        </span>
      </div>
      <div *ngIf="data.proposal.selectedSiteVisit" class="proposals-actions">
        <span class="active-delivery-date">
          Site Visit Date:
          {{
            (data.proposal.selectedSiteVisit?.date
              | date : "MM/dd/yyyy" : "UTC") +
              " (" +
              data.proposal.selectedSiteVisit?.slot +
              ")"
          }}
        </span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="type === 'proposals'">
    <div *ngIf="status === 'lost-bid' || status === 'bid-won'"></div>
  </ng-container>
  <div
    *ngIf="
      type === 'invitations' ||
      (type === 'proposals' && status === 'SUBMITTED' && isFixedPriced)
    "
    class="info-table-button"
    (click)="toggleDeclineModal()"
  >
    <span class="material-icons decline-icon">close</span>
    <p>Decline</p>
  </div>
  <div class="info-table-button address-pointer" [routerLink]="['/', type, id]">
    <span class="material-icons">visibility</span>
    <p>View</p>
  </div>

  <mapmodal-dialog
    [active]="mapActive"
    [siteType]="selectedSiteType"
    [siteId]="selectedSiteId"
    [data]="data"
    [address]="address"
    (modalClosed)="toggleMapModal(type, id)"
    [ngClass]="{ 'mapmodal-dialog--active': mapActive }"
  ></mapmodal-dialog>
</div>

<decline-dialog
  [siteId]="data.site.id"
  [active]="isDeclineActive"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [address]="address"
  [isFixedPrice]="isFixedPriced"
  (decline)="declineProposal($event)"
  (modalClosed)="toggleDeclineModal()"
  [ngClass]="{ 'documents-dialog--active': isDeclineActive }"
></decline-dialog>

<submit-for-review-dialog
  [active]="submitForReviewActive"
  [documents]="documents"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [address]="address"
  [status]="data.proposal.status"
  [siteId]="data.site.id"
  [isAlta]="isAlta"
  (modalClosed)="toggleSubmitForReviewModal()"
  (submitReview)="submitReview()"
  (submitRevision)="submitRevision()"
  [ngClass]="{ 'documents-dialog--active': submitForReviewActive }"
></submit-for-review-dialog>

<documents-dialog
  [data]="data"
  [active]="documentsActive"
  [documents]="documents"
  [siteType]="siteType"
  [address]="address"
  (modalClosed)="toggleCloseDocumentsModal()"
  (update)="updateDocuments($event)"
  [ngClass]="{ 'documents-dialog--active': documentsActive }"
></documents-dialog>

<notes-dialog
  [active]="notesActive"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [address]="address"
  (modalClosed)="toggleNotesModal()"
  [ngClass]="{ 'documents-dialog--active': notesActive }"
  [bidNotes]="bidNotes"
  [data]="data"
  (saveBidNotes)="saveBidNote($event)"
></notes-dialog>

<comments-dialog
  [active]="commentsActive"
  [documents]="documents"
  [siteType]="siteType"
  [address]="address"
  (modalClosed)="toggleCommentsModal()"
  [ngClass]="{ 'documents-dialog--active': commentsActive }"
></comments-dialog>

<site-visit-dialog
  [active]="siteVisitActive"
  [address]="address"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [siteDetail]="data"
  [proposal]="data?.proposal"
  (modalClosed)="toggleSiteVistModal()"
  (updateSiteVisitSiteDetail)="submitSiteVisit($event)"
/>

<expenses-dialog
  [data]="data"
  [active]="expensesActive"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [address]="address"
  (modalClosed)="toggleExpensesModal()"
  (saveExpenses)="saveExpense($event)"
  [ngClass]="{ 'documents-dialog--active': expensesActive }"
/>
